import { DateTime } from "../../utils/luxon.js";
import type { CustomerType } from "../CustomerType.js";
import type { DeliveryType } from "../DeliveryType.js";
import type { ScheduledOrderStopsSettingItem } from "../ScheduledOrderStopsSetting.js";
import { orderStopToDeliveryTypeAndCustomerTypeMap } from "../orderStopToDeliveryTypeAndCustomerTypeMap.js";

export function isDateDuringScheduledOrderStop(
	date: string,
	deliveryType: DeliveryType,
	customerType: CustomerType,
	scheduledOrderStops: ScheduledOrderStopsSettingItem[],
): boolean {
	const deliveryDate = DateTime.fromISO(date);
	return scheduledOrderStops.some(({ orderStop, from, to }: ScheduledOrderStopsSettingItem) => {
		const [stopDeliveryType, stopCustomerType] = orderStopToDeliveryTypeAndCustomerTypeMap[orderStop];
		return (
			stopDeliveryType === deliveryType &&
			stopCustomerType === customerType &&
			DateTime.fromISO(from) <= deliveryDate &&
			deliveryDate <= DateTime.fromISO(to)
		);
	});
}
